import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import SpinnerLoader from "./components/SpinnerLoader/SpinnerLoader";

console.log('🔍 [Main] Iniciando Billboard con autenticación Atlas-style...');
console.log('🔍 [Main] Variables de entorno:', {
  AUTH_SERVICE_URL: process.env.REACT_APP_AUTH_SERVICE_URL,
  AUTH_CLIENT_ID: process.env.REACT_APP_AUTH_CLIENT_ID,
  FRONTEND_DOMAIN: process.env.REACT_APP_FRONTEND_DOMAIN,
  NODE_ENV: process.env.NODE_ENV
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <SpinnerLoader />
  </Provider>
);

reportWebVitals();
